import type { ReactNode } from 'react'
import type React from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
interface Props {
  icon: ReactNode
  tooltipMessage: string
  id?: string
}

const IconWrapper = styled.div``

const Container = styled.div``

const TooltipIcon: React.FC<Props> = ({ icon, tooltipMessage, id }) => {
  const tooltipId = id ?? `tooltip-icon-${tooltipMessage.split(' ').join('-')}`
  return (
    <Container data-tip data-for={tooltipId}>
      <IconWrapper>{icon}</IconWrapper>
      <ReactTooltip
        backgroundColor="#34bebd"
        id={tooltipId}
        className="vouch-tooltip"
        place="top"
        effect="solid"
      >
        {tooltipMessage}
      </ReactTooltip>
    </Container>
  )
}

export default TooltipIcon
